// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import iView from 'iview'
import locale from 'iview/dist/locale/id-ID'
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "vue-snotify/styles/material.css"
import lodash from 'lodash';
import moment from 'moment';

import App from '@/App'
import router from '@/router'
import '@/snotify'
import store from '@/store'
import ajax from '@/ajax'

Vue.use(iView, { locale })
Vue.use(BootstrapVue);

Vue.prototype.$ajax = ajax
Vue.prototype.$_ = lodash
Vue.prototype.$moment = moment

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js